// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__muyn1","motion-opacity":"Header_motion-opacity__CrsqS","title":"Header_title___Mhy_"};